<template>
  <div class="px-4 py-3">
    <div>
      <v-row no-gutters>
        <!-- Phần "THÔNG TIN ĐƠN HÀNG" -->
        <v-col class="pr-2" cols="12" md="7" lg="8">
          <v-card
            class="py-3 px-4 ma-0"
            style="background: #F5F5F5;border: 0.25px solid #c9c8c8;"
            outlined
            tile
          >
            <div class="d-flex align-center justify-space-between">
              <div style="color: #AC0606; font-weight: 600; font-size: 14px;">
                THÔNG TIN ĐƠN HÀNG
              </div>
              <div>
                <v-btn
                  min-width="70"
                  small
                  color="#7889A5"
                  v-if="detailOrder.status == 1 && detailOrder.paidAmount == 0"
                  @click="cancelOrder()"
                >
                  Hủy đơn
                </v-btn>
                <v-btn
                  min-width="70"
                  class="mr-0"
                  small
                  color="#B9B9B9"
                  @click="backToList()"
                >
                  Thoát
                </v-btn>
              </div>
            </div>
            <hr
              style="background-color: #838383; height: 1px; border: 0;"
              class="my-2"
            />
            <div>
              <!-- Phần mã đơn hàng -->
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex">
                  <div>
                    <span style="color: #000000;">Mã đơn hàng: </span>
                    <span class="font-weight-bold" style="color: #AC0606;">
                      {{ detailOrder.code }}
                    </span>
                  </div>
                  <div class="ml-10">
                    <span style="color: #000000;">Trạng thái: </span>
                    <span
                      class="font-weight-bold"
                      style="color: #FFC700;"
                      :style="[
                        detailOrder.status == 1
                          ? { color: '#FFD643' }
                          : detailOrder.status == 2
                          ? { color: '#D83410' }
                          : { color: '#54DC52' },
                      ]"
                    >
                      {{ convertStatus(detailOrder.status) }}
                    </span>
                  </div>
                </div>
                <div>
                  <v-btn
                    min-width="70"
                    class="mr-0"
                    small
                    color="#FFFFFF"
                    style="color: #006CCF;"
                    outlined
                    @click="listeReceipt(detailOrder.numberOfReceipts)"
                  >
                    {{ `(${detailOrder.numberOfReceipts}) Phiếu thu` }}
                  </v-btn>
                  <v-btn
                    v-if="detailOrder.status == 1"
                    min-width="70"
                    class="ml-2 mr-0"
                    small
                    color="#FFC700"
                    style="color: #fff;"
                    @click="createReceipt()"
                  >
                    Tạo phiếu thu
                  </v-btn>
                </div>
              </div>

              <!-- Phần bảng sản phẩm -->
              <div class="mt-4">
                <v-simple-table height="300px" fixed-header>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th
                          class="text-left font-weight-bold"
                          style="min-width: 300px;"
                        >
                          Sản phẩm
                        </th>
                        <th
                          class="text-left font-weight-bold"
                          style="width: 160px;"
                        >
                          Đơn giá
                        </th>
                        <th
                          class="text-left font-weight-bold"
                          style="width: 60px;"
                        ></th>
                        <th
                          class="text-center font-weight-bold"
                          style="width: 160px;"
                        >
                          Số lượng
                        </th>
                        <th class="text-right font-weight-bold">
                          Thành tiền
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in detailOrder.products" :key="item.name">
                        <!-- Cột 'Sản phẩm' -->
                        <td>
                          <div class="font-weight-bold">
                            {{ item.name }}
                          </div>
                          <div>
                            <span style="color: #A4A4A4; font-weight: 600;">
                              Nhóm sản phẩm:
                            </span>
                            <span class="font-weight-bold">
                              {{ item.group.name }}
                            </span>
                          </div>
                          <div>
                            <span style="color: #A4A4A4; font-weight: 600;">
                              Loại sản phẩm:
                            </span>
                            <span class="font-weight-bold">
                              {{ item.productType }}
                            </span>
                          </div>
                        </td>
                        <!-- Cột 'Đơn giá' -->
                        <td>
                          <div class="font-weight-medium">
                            {{ formatPrice(item.price) }}
                          </div>
                        </td>
                        <!-- Cột 'x' -->
                        <td class="text-center">x</td>
                        <!-- Cột 'Số lượng' -->
                        <td class="text-center font-weight-bold">
                          {{ item.quantity }}
                        </td>
                        <!-- Cột 'Thành tiền' -->
                        <td class="text-right font-weight-bold">
                          {{ formatPrice(item.price * item.quantity) }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <!-- Phần ghi chú, note, thanh toán -->
              <div style="margin-top: 22px;">
                <v-row>
                  <v-col cols="12" sm="6" md="7">
                    <div>
                      <div style="color: #AC0606; font-weight: 600">
                        Ghi chú đơn hàng
                      </div>
                      <v-textarea
                        auto-grow
                        variant="outlined"
                        rows="3"
                        row-height="25"
                        outlined
                        class="note mt-1"
                        disabled
                        v-model="detailOrder.description"
                      ></v-textarea>
                    </div>
                    <div>
                      <div style="color: #AC0606; font-weight: 600">
                        Note vận hành xếp lớp
                      </div>
                      <v-textarea
                        auto-grow
                        variant="outlined"
                        rows="3"
                        row-height="25"
                        outlined
                        class="note mt-1"
                        disabled
                        v-model="detailOrder.operationNote"
                      ></v-textarea>
                    </div>
                  </v-col>

                  <v-col cols="6" md="5">
                    <div class="pl-3">
                      <div style="color: #AC0606; font-weight: 600">
                        Thông tin thanh toán
                      </div>
                      <div class="mt-3">
                        <div
                          class="d-flex align-center justify-space-between mt-2"
                        >
                          <div style="color: #000; min-width: 160px; ">
                            Tổng giá trị đơn hàng
                          </div>
                          <div class="info-payment-price">
                            {{ formatPrice(detailOrder.totalAmount) }}
                          </div>
                        </div>
                        <div
                          class="d-flex align-center justify-space-between mt-2"
                        >
                          <div style="color: #000; min-width: 160px; ">
                            Phụ phí
                          </div>
                          <div class="info-payment-price">
                            {{ formatPrice(surcharge) }}
                          </div>
                        </div>
                        <div
                          class="d-flex align-center justify-space-between mt-2"
                        >
                          <div style="color: #000; min-width: 160px; ">
                            Đã thanh toán
                          </div>
                          <div class="info-payment-price">
                            {{ formatPrice(detailOrder.paidAmount) }}
                          </div>
                        </div>
                        <div
                          class="d-flex align-center justify-space-between mt-2"
                        >
                          <div style="color: #000; min-width: 160px; ">
                            Cần thanh toán
                          </div>
                          <div class="info-payment-price">
                            {{
                              formatPrice(
                                detailOrder.totalAmount - detailOrder.paidAmount
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col class="pl-2" cols="12" md="5" lg="4">
          <!-- Phần "THÔNG TIN KHÁCH HÀNG" -->
          <v-card
            class="py-3 px-4 pa-2 ma-0"
            style="background: #F5F5F5;border: 0.25px solid #c9c8c8;"
            outlined
            tile
          >
            <div class="mt-1">
              <div style="color: #AC0606; font-weight: 600; font-size: 14px;">
                THÔNG TIN KHÁCH HÀNG
              </div>
              <div class="mt-6">
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Tên khách hàng
                  </div>
                  <div class="info-payment-price text-left">
                    {{ _.get(detailOrder, "receiver.name", null) }}
                  </div>
                </div>
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Số điện thoại
                  </div>
                  <div class="info-payment-price text-left">
                    {{ _.get(detailOrder, "receiver.mobile", null) }}
                  </div>
                </div>
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Email
                  </div>
                  <div class="info-payment-price text-left">
                    {{ _.get(detailOrder, "receiver.email", null) }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Địa chỉ -->
            <div class="mt-10">
              <div style="color: #AC0606; font-weight: 600; font-size: 14px;">
                Địa chỉ
              </div>
              <div class="my-3">
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Tỉnh/Thành
                  </div>
                  <div class="info-payment-price text-left">
                    {{ _.get(detailOrder, "address.province", null) }}
                  </div>
                </div>
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Quận/Huyện
                  </div>
                  <div class="info-payment-price text-left">
                    {{ _.get(detailOrder, "address.district", null) }}
                  </div>
                </div>
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Phường/Xã
                  </div>
                  <div class="info-payment-price text-left">
                    {{ _.get(detailOrder, "address.ward", null) }}
                  </div>
                </div>
                <div class="d-flex align-start justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Địa chỉ chi tiết
                  </div>
                  <div
                    class="info-payment-price text-left"
                    style="min-height: 75px;"
                  >
                    {{ _.get(detailOrder, "address.addressDetail", null) }}
                  </div>
                </div>
              </div>
            </div>
          </v-card>

          <!-- Phần 'THÔNG TIN NGƯỜI TẠO ĐƠN HÀNG' -->
          <v-card
            class="pa-2 ma-0 mt-4"
            style="background: #F5F5F5;border: 0.25px solid #c9c8c8;"
            outlined
            tile
          >
            <div class="mt-1">
              <div style="color: #AC0606; font-weight: 600; font-size: 14px;">
                THÔNG TIN NGƯỜI TẠO ĐƠN HÀNG
              </div>
              <div class="d-flex align-center justify-space-between mt-4">
                <div style="color: #000; min-width: 160px; ">
                  Người tạo đơn
                </div>
                <div class="info-payment-price text-left">
                  {{ _.get(detailOrder.createdBy, "fullName", null) }}
                </div>
              </div>
              <div class="d-flex align-center justify-space-between mt-2">
                <div style="color: #000; min-width: 160px; ">
                  Ngày tạo đơn
                </div>
                <div class="info-payment-price text-left">
                  {{ formatDate(detailOrder.createdAt) }}
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Popup Phiếu thu -->
    <popupReceipt
      v-if="dialogReceipt"
      :dialogReceipt="dialogReceipt"
      :dataDialogReceipt="dataDialogReceipt"
      @close-popup="dialogReceipt = false"
      @update-success="getDetailOrder()"
    ></popupReceipt>
  </div>
</template>

<script>
// import { formatPrice } from "@/helpers/utils";
import OrderRepository from "@/pages/order-management/services/OrderRepository.js";
import { formatDate } from "../../helpers/utils";

export default {
  name: "VhPosFrontendCreateOrder",
  components: {
    popupReceipt: () => import("@/pages/payment-hub/receipts.vue"),
  },

  data() {
    return {
      orderId: null,
      detailOrder: {
        code: null,
        status: null,
      },
      surcharge: 0,
      dialogReceipt: false,
      dataDialogReceipt: {},
    };
  },

  created() {
    this.orderId = this.$route.params.orderId;
    this.dataDialogReceipt.orderId = this.orderId;
    this.getDetailOrder();
  },

  methods: {
    // Lấy chi tiết đơn hàng
    async getDetailOrder() {
      this.dialogReceipt = false;
      const params = {
        // productType: "exam",
      };
      const res = await OrderRepository.detailOrder(this.orderId, params);
      if (res.success) {
        this.detailOrder = res.data;
      }
    },

    // Định dạng trạng thái đơn
    convertStatus(status) {
      var text = null;
      switch (status) {
        case 1:
          text = "Chờ thanh toán";
          break;
        case 2:
          text = "Đã huỷ";
          break;
        case 3:
          text = "Đã thanh toán";
          break;

        default:
          text = "Chưa xác nhận";
          break;
      }
      return text;
    },

    // Huỷ đơn hàng
    async cancelOrder() {
      const data = {
        status: 2,
      };
      const res = await OrderRepository.cancelOrder(this.orderId, data);
      if (res.success) {
        this.$swal({
          icon: "success",
          title: "Thành công",
          text: "Thao tác thành công!",
        }).then(() => {
          this.getDetailOrder();
        });
      } else {
        this.$swal({
          icon: "error",
          title: "Lỗi",
          text: "Opps! Đã có lỗi xảy ra",
        });
      }
    },

    // Tạo phiếu thu
    createReceipt() {
      this.dialogReceipt = true;
    },

    // Chuyển đến màn danh sách phiếu thu
    listeReceipt(value) {
      if (value > 0) {
        const url = this.$router.resolve({
          name: "PaymentHub",
          query: {
            keyword: this.orderId,
          },
        });
        window.open(url.href, "_blank");
      }
    },

    // Quay lại màn danh sách
    backToList() {
      this.$router.push({
        name: "OrderManagement",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__control {
  min-height: 10px;
}

.v-label {
  font-size: 10px;
}
::v-deep .v-data-table th {
  font-size: 16px !important;
}
::v-deep .v-data-table td,
::v-deep .v-data-table table thead tr th {
  font-size: 14px !important;
  padding: 15px 12px !important;
}
.info-payment-price {
  height: 33px;
  background: #d9d9d9;
  border: 1px solid #00000033;
  border-radius: 3px;
  width: 100%;
  text-align: right;
  padding: 5px 4px;
}
::v-deep .note .v-input__slot {
  background: #fff !important;
}
</style>
